<template>
  <div>
    <center><h6>Confirm</h6></center>
    <h5 class="info-text">Review the information you have provided.</h5>
    <div class="row justify-content-center">
      
      <div class="col-12 col-sm-10 mt-3">
        <ul v-html="formatWizardModel()"></ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['wizardModel'],
    
    methods: {
      formatWizardModel () {
        console.log (this.wizardModel)
        var outputString = "<li>Income : " + this.formatMoney(this.wizardModel.income) + " </li>"
        outputString += "<li>Rent : " + this.formatMoney(this.wizardModel.rent) + " </li>"
        outputString += "<li>Feeding : " + this.formatMoney(this.wizardModel.food) + " </li>"
        outputString += "<li>Transportation : " + this.formatMoney(this.wizardModel.transportation) + " </li>"
        outputString += "<li>Airtime : " + this.formatMoney(this.wizardModel.airtime) + " </li>"
        outputString += "<li>Debt : " + this.formatMoney(this.wizardModel.debt) + " </li>"

        return outputString
      },

      formatMoney (amount) {
        let formattedAmount = new Intl.NumberFormat('en-US', 
          { style: 'currency', currency: 'NGN' }).format(amount).replace('NGN', '₦')

        return formattedAmount
      }
    },
    mounted () {
      this.formatWizardModel()
    }
  }
</script>
<style lang="scss">
</style>
